<div class="popup">
  <div class="popup__title">Flash player</div>
  <div class="popup__text">
    Please enable Flash Player to play this game
  </div>
  <div class="popup__actions">
    <a class="btn big btn--primary" [href]="flash.activationUrl" (click)="modal.close()">Enable</a>
  </div>
</div>
